const localizacoes = [

    {
        "id": 1,
        "icon":"../../Assets/img/casaDosFriosLogo.svg",
        "name": "Casa dos Frios",
        "address":"Av. Rui Barbosa, 412 - Graças, Recife - PE ",
        "phone":"+55 81 2125-0200",
        "coordinates": [-8.04831, -34.89899]
    },
    
    
    {
        "id": 2,
        "img":"../../Assets/img/casaDosFriosLogo.svg",
        "name": "Casa dos Frios",
        "address":"Av. Eng. Domingos Ferreira, 1920 - Boa Viagem, Recife - PE ",
        "phone":"+55 81 3325-0676",
        "coordinates": [-8.10624, -34.89023]
    },
    
    
    
    {
        "id": 3,
        "img":"../../Assets/img/casaDosFriosLogo.svg",
        "name": "Casa dos Frios",
        "address":"R. Padre Carapuceiro, 777 - Boa Viagem, Recife - PE ",
        "phone":"Não consta",
        "coordinates": [-8.11894,-34.90482]

    },
    
    
    
    {
        "id": 4,
        "img":"../../Assets/img/casaDosFriosLogo.svg",
        "name": "Casa dos Frios",
        "address":"Praça Ministro Salgado Filho s/n - Imbiribeira, Recife - PE ",
        "phone":"+55 81 3326-6789",
        "coordinates": [-8.13165,-34.91858]
    },
    
   
  

    {
        "id": 5,
        "img":"../../Assets/img/restauranteTioPepeLogo.svg",
        "name": "Restaurante Tio Pepe",
        "address":"R. Alm. Tamandaré, 170 - Boa Viagem, Recife - PE ",
        "phone":"+55 81 3341-7153",
        "coordinates": [-8.13405, -34.90834]
    },


    {
        "id": 6,
        "img":"../../Assets/img/restauranteParraxaxaLogo.svg",
        "name": "Restaurante Parraxaxá",
        "address":"R. Igarassu, 40 - Casa Forte, Recife - PE ",
        "phone":"+55 81 3268-4169",
        "coordinates": [-8.03816, -34.91189 ]
    },

    {
        "id": 7,
        "img":"../../Assets/img/restauranteParraxaxaLogo.svg",
        "name": "Restaurante Parraxaxá",
        "address":"Av. Fernando Simões Barbosa, 1200 - Boa Viagem, Recife - PE ",
        "phone":"+55 81 3463-7874",
        "coordinates": [-8.12799, -34.90215]
    },
    
    {
        "id": 8,
        "img":"../../Assets/img/restauranteTerracoLogo.svg",
        "name": "Terraço Capibaribe | Cozinha Contemporânea ",
        "address":"R. Antônio Vitrúvio, 113 - Poço da Panela, Recife - PE ",
        "phone":"Não consta",
        "coordinates": [-8.0361, -34.92582]
    },

   {
        "id": 9,
        "img":"../../Assets/img/restauranteCafeTao.svg",
        "name": " Café Tão - Cafeteria",
        "address":"Av. Santos Dumont, 345 - Aflitos, Recife - PE",
        "phone":"+55 81 3429-9406",
        "coordinates": [-8.03795, -34.89873]
    },
    

    {
        "id": 10,
        "img":"../../Assets/img/cafeSaoBraz.svg",
        "name": " Coffee Shop São Braz",
        "address":" R. Dr. João Santos Filho, 255 -  L1 - SS43 -Parnamirim, Recife - PE",
        "phone":"+55 81 3265-0917",
        "coordinates": [-8.03694,  -34.9128]
    },

    {
        "id": 11,
        "img":"../../Assets/img/cafeSaoBraz.svg",
        "name": " Coffee Shop São Braz",
        "address":"R. das Pernambucanas, 265 - Graças, Recife - PE",
        "phone":"+55 81 3049-4387",
        "coordinates": [-8.051, -34.90134]
    },

    {
        "id": 12,
        "img":"../../Assets/img/cafeSaoBraz.svg",
        "name": " Coffee Shop São Braz",
        "address":"Av. Visc. de Suassuna, 140 - Santo Amaro, Recife - PE",
        "phone":"+55 81 98158-4415",
        "coordinates": [-8.05428,  -34.8833]
    },

    {
        "id": 13,
        "img":"../../Assets/img/cafeSaoBraz.svg",
        "name": " Coffee Shop São Braz",
        "address":"R José de Alencar, 105, Loja 109 E - Boa Vista, Recife - PE",
        "phone":"+55 81 3222-7334",
        "coordinates": [-8.06024, -34.88739]
    },

    {
        "id": 14,
        "img":"../../Assets/img/cafeSaoBraz.svg",
        "name": " Coffee Shop São Braz",
        "address":"R. Dr. João Asfora, 26 - loja 1 - Ilha do Leite, Recife - PE",
        "phone":"+55 81 3040-6062",
        "coordinates": [-8.0634, -34.89512]
    },

    {
        "id": 15,
        "img":"../../Assets/img/cafeSaoBraz.svg",
        "name": " Coffee Shop São Braz",
        "address":"Av. República do Líbano, 251 - Pina, Recife - PE",
        "phone":"+55 81 3049-4312",
        "coordinates": [-8.08569,  -34.8954]
    },

    {
        "id": 16,
        "img":"../../Assets/img/cafeSaoBraz.svg",
        "name": " Coffee Shop São Braz",
        "address":"R. Maria Carolina, 315 - Boa Viagem, Recife - PE",
        "phone":"+55 81 3037-0338",
        "coordinates": [-8.11454, -34.89604  ]
    },

    {
        "id": 17,
        "img":"../../Assets/img/cafeSaoBraz.svg",
        "name": " Coffee Shop São Braz",
        "address":"R. Carlos Pereira Falcão, 136 - Loja 5/6 - Boa Viagem, Recife - PE",
        "phone":"+55 81 3322-7259",
        "coordinates": [-8.12597, -34.89936]
    },

    {
        "id": 18,
        "img":"../../Assets/img/cafeSaoBraz.svg",
        "name": " Coffee Shop São Braz",
        "address":"Praça Min. Salgado Filho, 4775 - Imbiribeira, Recife - PE",
        "phone":"+55 81 97110-3617",
        "coordinates": [-8.13148, -34.91851]

    },

    {
        "id": 19,
        "img":"../../Assets/img/cafeSaoBraz.svg",
        "name": " Coffee Shop São Braz",
        "address":"R. Baltazar Passos, 520 - Boa Viagem, Recife - PE",
        "phone":"+55 81 3877-3412",
        "coordinates": [-8.14272, -34.90967 ]
    },


    {
        "id": 20,
        "img":"../../Assets/img/cafeMaisProsa.svg",
        "name": " Café mais Prosa",
        "address":"galeria chalé - R. Barão de Itamaracá, 284 - loja 4 - Espinheiro, Recife - PE",
        "phone":"+55 81 3048-4008",
        "coordinates": [-8.04368,  -34.89314]
    },


    {
        "id": 21,
        "img":"../../Assets/img/restauranteEntreAmigosMar.svg",
        "name": "Entre Amigos Praia",
        "address":"Avenida Boa Viagem, 760- Boa Viagem, Recife -PE",
        "phone":"+55 81 3127-2510",
        "coordinates": [-8.09824, -34.88407]
    },

  


    {
        "id": 22,
        "img":"../../Assets/img/restauranteCamaradaMar.svg",
        "name": "Camarada Camarão",
        "address":"Av. República do Líbano, 251 - Boa Viagem, Recife - PE ",
        "phone":"+55 81 98164-4358",
        "coordinates": [ -8.08611, -34.89422]

    },


    {
        "id": 23,
        "img":"../../Assets/img/restauranteNauMar.svg",
        "name": "Nau Frutos do Mar",
        "address":"Av. Eng. Domingos Ferreira, 1910 - Boa Viagem, Recife - PE",
        "phone":"+55 81 3205-8456",
        "coordinates": [  -8.10537,  -34.8903]

    },


    {
        "id": 24,
        "img":"../../Assets/img/restauranteVieiraMar.svg",
        "name": "Vieira Restaurante e Bar",
        "address":"R. Araguari, 47 - Brasília Teimosa, Recife - PE",
        "phone":"+55 81 3078-5484",
        "coordinates": [  -8.08943, -34.88123]

    },

    {
        "id": 25,
        "img":"../../Assets/img/restauranteBarDoCaboMar.svg",
        "name": "Bar do Cabo",
        "address":"R. Nanuque, 37 - Brasília Teimosa, Recife - PE",
        "phone":"+55 81 4040-4420",
        "coordinates": [   -8.08775, -34.88044]
    },

    {
        "id": 26,
        "img":"../../Assets/img/restauranteIlhaDosNavegantesMar.svg",
        "name": "Ilha dos Navegantes Frutos do Mar e Grelhados",
        "address":"R. dos Navegantes, 2055 - Boa Viagem, Recife - PE",
        "phone":"+55 81 3326-5317",
        "coordinates": [   -8.115, -34.89305]
    },

    
    {
        "id": 27,
        "img":"../../Assets/img/restauranteAltar.svg",
        "name": "Altar Cozinha Ancestral",
        "address":"Rua Frei Cassimiro, 449 - Santo Amaro, Recife - PE",
        "phone":"Não consta",
        "coordinates": [    -8.04601,  -34.88132]
    },


    {
        "id": 28,
        "img":"../../Assets/img/restauranteBarDoSamuray.svg",
        "name": "Bar do Samuray",
        "address":"R. Badejo, 272 - Brasília Teimosa, Recife - PE",
        "phone":"+55 81 99879-8853",
        "coordinates": [    -8.08179, -34.87902]
    },

    {
        "id": 29,
        "img":"../../Assets/img/restauranteBarTonhaoCotidiano.svg",
        "name": "Bar do Tonhão",
        "address":"R. Amaro Coutinho, 339 - Encruzilhada, Recife - PE",
        "phone":"+55 81 3034-8085",
        "coordinates": [   -8.03508, -34.89356]
    },


    {
        "id": 30,
        "img":"../../Assets/img/tapiocaDamiao.svg",
        "name": " Tapioca Rendada do Damião",
        "address":"Av. Rio Branco, 155-27 - Recife-PE",
        "phone":" +55 81 98463-6772",
        "coordinates": [-8.06254, -34.87274]
    },

    {
        "id": 31,
        "img":"../../Assets/img/tapiocaDamiao.svg",
        "name": " Tapioca Rendada do Damião",
        "address":"Av. Conselheiro Aguiar, 3005 - Boa Viagem, Recife - PE",
        "phone":"+55 81 99714-3097",
        "coordinates": [-8.11597, -34.89408]
    },

    {
        "id": 32,
        "img":"../../Assets/img/tapiocaDamiao.svg",
        "name": " Tapioca Rendada do Damião",
        "address":"Rua Antônio Lumack do Monte, 203 - Loja 03 - Boa Viagem, Recife - PE",
        "phone":"Não consta",
        "coordinates": [-8.11821, -34.90217]
    },

    {
        "id": 33,
        "img":"../../Assets/img/tapiocaDamiao.svg",
        "name": " Tapioca Rendada do Damião",
        "address":"R. Ernesto de Paula Santos - Boa Viagem, Recife - PE",
        "phone":"+55 81 99682-9588",
        "coordinates": [-8.12439, -34.90629]
    },

    {
        "id": 34,
        "img":"../../Assets/img/tapiocaDamiao.svg",
        "name": " Tapioca Rendada do Damião",
        "address":"Av. Boa Viagem, Quiosque 34 - Boa Viagem, Recife - PE",
        "phone":"+55 81 98158-4415",
        "coordinates": [-8.03795, -34.89873]
    },

    {
        "id": 35,
        "img":"../../Assets/img/tapiocaDamiao.svg",
        "name": " Tapioca Rendada do Damião",
        "address":"R. Prof. Mário de Castro, 361 - Boa Viagem, Recife - PE",
        "phone":"+55 81 98158-4415",
        "coordinates": [-8.13606, -34.90513]
    },


    {
        "id": 36,
        "img":"../../Assets/img/restauranteBarGeralda.svg",
        "name": "Bar da Geralda",
        "address":"R. do Morro da Conceição, 486 - Morro da Conceição, Recife - PE",
        "phone":"+55 81 3442-1382",
        "coordinates": [-8.01916, -34.91504]
    },

    {
        "id": 37,
        "img":"../../Assets/img/restauranteBarBecaBar.svg",
        "name": "Beca Bar: Bar do Arrumadinho",
        "address":"R. Pedro Afonso, 326 - Santo Amaro, Recife - PE, 50100-220",
        "phone":"+55 81 3423-9008",
        "coordinates": [  -8.04918, -34.88181]
    },


    {
        "id": 38,
        "img":"../../Assets/img/restauranteBarMangai.svg",
        "name": "Mangai",
        "address":"Av. Eng. Domingos Ferreira, 1910 - Boa Viagem, Recife - PE",
        "phone":"+55 81 3205-8455",
        "coordinates": [  -8.10537,  -34.8903]
    },


    {
        "id": 39,
        "img":"../../Assets/img/restauranteJoaoDaCarneDeSol.svg",
        "name": "João da Carne de Sol",
        "address":"R. José Bonifácio, 385 - Madalena, Recife - PE",
        "phone":"+55 81 3445-0454",
        "coordinates": [    -8.0478, -34.90663]
    },


    {
        "id": 40,
        "img":"../../Assets/img/restauranteCantinhoDaBel.svg",
        "name": "Cantinho da Bel",
        "address":"R. Diogo Álvares, 206 - Zumbi, Recife - PE, 50711-110",
        "phone":"+55 81 3446-1966",
        "coordinates": [    -8.04834, -34.91687]
    },

    {
        "id": 41,
        "img":"../../Assets/img/restauranteIlhaSertaneja.svg",
        "name": "Ilha Sertaneja",
        "address":"Rua Dr. Nilo Dornelas Câmara, 16 - Boa Viagem, Recife - PE",
        "phone":"+55 81 3048-5886",
        "coordinates": [    -8.13173, -34.90094]
    },


    {
        "id": 42,
        "img":"../../Assets/img/feiraBomJesus.svg",
        "name": "Feira de Artesanato do Bom Jesus",
        "address":"R. do Bom Jesus - Recife, PE",
        "phone":"+55 81 98102-2130",
        "coordinates": [ -8.06188,-34.87127]
    },

    
    {
        "id": 43,
        "img":"../../Assets/img/feiraBomJesus.svg",
        "name": "Feira de Artesanato do Bom Jesus",
        "address":"Praça do Arsenal - Recife, PE",
        "phone":"Não consta",
        "coordinates": [ -8.06103,-34.87129]
    },


    {
        "id": 44,
        "img":"../../Assets/img/feiraDaAurora.svg",
        "name": "Feira da Aurora",
        "address":"R. da Aurora, 1034 - Boa Vista, Recife - PE",
        "phone":"Não consta",
        "coordinates": [ -8.0527,-34.87536]
    },

    {
        "id": 45,
        "img":"../../Assets/img/recifeCoffe.svg",
        "name": "Recife Coffe",
        "address":"Museu do Paço do Frevo: Praça do Arsenal da Marinha, 91, Bairro do Recife",
        "phone":"Não consta",
        "coordinates": [-8.0631, -34.8711]
    },

    
    {
        "id": 46,
        "img":"../../Assets/img/espacoAgroecologico.svg",
        "name": "Espaço Agroecológico de Setúbal",
        "address":"Setúbal - Av. Mal. Juarez Távora, 41-99 - Boa Viagem, Recife - PE",
        "phone":"+55 81 99982-4312",
        "coordinates": [  -8.13685, -34.90816]
    },

     
    {
        "id": 47,
        "img":"../../Assets/img/festivalTorresmoPork.svg",
        "name": "festival Torresmo Land",
        "address":"R. Olavo Bilac, 20a - Boa Viagem, Recife - PE",
        "phone":"Não consta",
        "coordinates": [  -8.12926,   -34.9033]
    },

    {
        "id": 48,
        "img":"../../Assets/img/festivalYakissoba.svg",
        "name": "Festival de Yakissoba e Karê",
        "address":"Av. Pref. Antônio Pereira, 395 - Várzea, Recife - PE",
        "phone":"Não consta",
        "coordinates": [  -8.06328,  -34.98645]
    }
    
   
]

export {localizacoes};